import { gql } from '@apollo/client';
import { webhookClient } from '../../../../services/webhookClient';

export const insertQuestionnaireResponseMutation = gql`
  mutation ($object: dans_fund_responses_insert_input!) {
    insert_dans_fund_responses_one(object: $object) {
      id
    }
  }
`;

export const sendEmail = async (emailData: string) => webhookClient.postAnon(`send-grid/questionnaire-results`, emailData);
